<div
  class="mxdr-service-config"
  [class.narrow-layout]="isNarrowLayout()"
>
  <div class="service-header mb-3">
    <h3 class="service-title">
      <kendo-svg-icon
        [icon]="shieldCheckIcon"
        class="me-2"
      ></kendo-svg-icon>
      mXDR Configuration
    </h3>
    <p class="service-subtitle text-muted">Extended Detection & Response Service Setup</p>
  </div>

  <form
    [formGroup]="mxdrForm"
    class="row g-3"
  >
    <!-- Service Selection Section -->
    <div class="col-12">
      <div class="config-section">
        <h5 class="section-title mb-3">
          <kendo-svg-icon
            [icon]="gearIcon"
            class="me-2"
          ></kendo-svg-icon>
          Select XDR Service
        </h5>
        <div class="row g-3">
          @for (service of xdrServiceOptions; track service.value) {
            <div
              class="col-12"
              [class.col-xl-4]="!isNarrowLayout()"
            >
              <div
                class="service-option-card"
                [class.selected]="isServiceSelected(service.value)"
                (click)="selectService(service.value)"
                style="cursor: pointer"
              >
                <div class="service-option-header">
                  <kendo-svg-icon
                    [icon]="
                      service.value === 'xdr-standard'
                        ? shieldCheckIcon
                        : service.value === 'xdr-govcloud'
                          ? serverIcon
                          : userIcon
                    "
                    class="service-icon"
                  ></kendo-svg-icon>
                  <h6 class="service-name">{{ service.text }}</h6>
                </div>
                <p class="service-description">{{ service.description }}</p>
                <div class="selection-indicator">
                  @if (isServiceSelected(service.value)) {
                    <kendo-svg-icon
                      [icon]="infoCircleIcon"
                      class="selected-icon"
                    ></kendo-svg-icon>
                    <span class="selected-text">Selected</span>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- Standard and GovCloud Specific Fields -->
    @if (showStandardGovCloudFields()) {
      <div class="col-12">
        <div class="config-section">
          <h5 class="section-title mb-3">
            <kendo-svg-icon
              [icon]="shieldCheckIcon"
              class="me-2"
            ></kendo-svg-icon>
            {{ selectedService() === 'xdr-govcloud' ? 'GovCloud' : 'Standard' }} XDR Configuration
          </h5>
          <div class="row g-3">
            <!-- Left Column -->
            <div
              class="col-12"
              [class.col-lg-6]="!isNarrowLayout()"
            >
              <!-- Section 1: XDR Information -->
              <div class="config-section">
                <h5 class="section-title mb-3">
                  <kendo-svg-icon
                    [icon]="gearIcon"
                    class="me-2"
                  ></kendo-svg-icon>
                  XDR Information
                </h5>
                <div class="row g-3">
                  <!-- Extended Log Retention -->
                  <div
                    class="col-12"
                    [class.col-lg-6]="!isNarrowLayout()"
                  >
                    <kendo-formfield>
                      <kendo-label
                        [for]="extendedLogRetention"
                        text="Extended Log Retention"
                      ></kendo-label>
                      <kendo-switch
                        formControlName="extendedLogRetention"
                        #extendedLogRetention
                        offLabel="No"
                        onLabel="Yes"
                      ></kendo-switch>
                      <kendo-formhint>
                        <kendo-svg-icon
                          [icon]="infoCircleIcon"
                          class="me-1"
                        ></kendo-svg-icon>
                        Standard Log Retention: 30 Days Hot, 90 Days Cold - XLR increases to 365 days of Cold Storage
                      </kendo-formhint>
                    </kendo-formfield>
                  </div>

                  <!-- AD Users -->
                  <div
                    class="col-12"
                    [class.col-lg-6]="!isNarrowLayout()"
                  >
                    <kendo-formfield>
                      <kendo-label
                        [for]="adUsers"
                        text="# of AD Users *"
                      ></kendo-label>
                      <kendo-numerictextbox
                        formControlName="adUsers"
                        #adUsers
                        [min]="1"
                        placeholder="Enter number"
                        class="w-100"
                      ></kendo-numerictextbox>
                      <kendo-formhint>
                        <kendo-svg-icon
                          [icon]="infoCircleIcon"
                          class="me-1"
                        ></kendo-svg-icon>
                        This includes shared mailboxes and service accounts
                      </kendo-formhint>
                      @if (mxdrForm.get('adUsers')?.invalid && mxdrForm.get('adUsers')?.touched) {
                        <kendo-formerror>
                          <kendo-svg-icon
                            [icon]="exclamationTriangleIcon"
                            class="me-1"
                          ></kendo-svg-icon>
                          Required (minimum 1)
                        </kendo-formerror>
                      }
                    </kendo-formfield>
                  </div>

                  <!-- Servers -->
                  <div
                    class="col-12"
                    [class.col-lg-6]="!isNarrowLayout()"
                  >
                    <kendo-formfield>
                      <kendo-label
                        [for]="servers"
                        text="# of Servers *"
                      ></kendo-label>
                      <kendo-numerictextbox
                        formControlName="servers"
                        #servers
                        [min]="1"
                        placeholder="Enter number"
                        class="w-100"
                      ></kendo-numerictextbox>
                      <kendo-formhint>
                        <kendo-svg-icon
                          [icon]="infoCircleIcon"
                          class="me-1"
                        ></kendo-svg-icon>
                        ALL Linux and Windows servers
                      </kendo-formhint>
                      @if (mxdrForm.get('servers')?.invalid && mxdrForm.get('servers')?.touched) {
                        <kendo-formerror>
                          <kendo-svg-icon
                            [icon]="exclamationTriangleIcon"
                            class="me-1"
                          ></kendo-svg-icon>
                          Required (minimum 1)
                        </kendo-formerror>
                      }
                    </kendo-formfield>
                  </div>

                  <!-- XDR Service Options -->
                  <div class="col-12">
                    <kendo-formfield>
                      <kendo-label
                        [for]="xdrServiceOption"
                        text="XDR Service Option *"
                      ></kendo-label>
                      <kendo-dropdownlist
                        formControlName="xdrServiceOption"
                        #xdrServiceOption
                        [data]="xdrServiceDeliveryOptions()"
                        textField="text"
                        valueField="value"
                        placeholder="Select XDR service option"
                        class="w-100"
                      ></kendo-dropdownlist>
                      @if (mxdrForm.get('xdrServiceOption')?.invalid && mxdrForm.get('xdrServiceOption')?.touched) {
                        <kendo-formerror>
                          <kendo-svg-icon
                            [icon]="exclamationTriangleIcon"
                            class="me-1"
                          ></kendo-svg-icon>
                          XDR service option selection is required
                        </kendo-formerror>
                      }
                    </kendo-formfield>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6">
              <!-- Section 2: Appliance Information -->
              <div class="config-section">
                <h5 class="section-title mb-3">
                  <kendo-svg-icon
                    [icon]="boxIcon"
                    class="me-2"
                  ></kendo-svg-icon>
                  Appliance Information
                </h5>
                <div class="row g-3">
                  <div class="col-md-6">
                    <kendo-formfield>
                      <kendo-label
                        [for]="appliances"
                        text="# of Appliances"
                      ></kendo-label>
                      <kendo-numerictextbox
                        formControlName="appliances"
                        #appliances
                        [min]="0"
                        placeholder="Enter number"
                        class="w-100"
                      ></kendo-numerictextbox>
                    </kendo-formfield>
                  </div>

                  <div
                    class="col-12"
                    [class.col-lg-6]="!isNarrowLayout()"
                  >
                    <kendo-formfield>
                      <kendo-label
                        [for]="virtualOS"
                        text="Virtual OS (If Virtual Appliance)"
                      ></kendo-label>
                      <kendo-dropdownlist
                        formControlName="virtualOS"
                        #virtualOS
                        [data]="virtualOSOptions"
                        textField="text"
                        valueField="value"
                        placeholder="Select OS"
                        class="w-100"
                      ></kendo-dropdownlist>
                    </kendo-formfield>
                  </div>

                  @if (hasAppliances()) {
                    <div class="col-12">
                      <kendo-formfield>
                        <kendo-label
                          [for]="applianceModels"
                          text="Model of Appliances"
                        ></kendo-label>
                        <kendo-multiselect
                          formControlName="applianceModels"
                          #applianceModels
                          [data]="applianceModelOptions"
                          textField="text"
                          valueField="value"
                          placeholder="Select models"
                          class="w-100"
                        ></kendo-multiselect>
                      </kendo-formfield>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }

    <!-- CMMC Specific Fields -->
    @if (showCmmcFields()) {
      <div class="col-12">
        <div class="config-section">
          <h5 class="section-title mb-3">
            <kendo-svg-icon
              [icon]="userIcon"
              class="me-2"
            ></kendo-svg-icon>
            CMMC XDR Configuration
          </h5>
          <div class="row g-3">
            <!-- Total Number Of Machines -->
            <div
              class="col-12"
              [class.col-lg-6]="!isNarrowLayout()"
            >
              <kendo-formfield>
                <kendo-label
                  [for]="totalMachines"
                  text="Total # of Machines *"
                ></kendo-label>
                <kendo-numerictextbox
                  formControlName="totalMachines"
                  #totalMachines
                  [min]="1"
                  [value]="mxdrForm.get('totalMachines')?.value || 0"
                  placeholder="Enter number of machines"
                  class="w-100"
                  (valueChange)="onTotalMachinesChange($event)"
                ></kendo-numerictextbox>
                <kendo-formhint>
                  <kendo-svg-icon
                    [icon]="infoCircleIcon"
                    class="me-1"
                  ></kendo-svg-icon>
                  Total number of endpoints to be protected
                </kendo-formhint>
                @if (mxdrForm.get('totalMachines')?.invalid && mxdrForm.get('totalMachines')?.touched) {
                  <kendo-formerror>
                    <kendo-svg-icon
                      [icon]="exclamationTriangleIcon"
                      class="me-1"
                    ></kendo-svg-icon>
                    Total machines is required and must be at least 1
                  </kendo-formerror>
                }
              </kendo-formfield>
            </div>

            <!-- Total Daily Ingestion -->
            <div
              class="col-12"
              [class.col-lg-6]="!isNarrowLayout()"
            >
              <kendo-formfield>
                <kendo-label
                  [for]="totalDailyIngestion"
                  text="Total Daily Ingestion (GB) *"
                ></kendo-label>
                <kendo-numerictextbox
                  formControlName="totalDailyIngestion"
                  #totalDailyIngestion
                  [min]="0.1"
                  [decimals]="1"
                  [value]="mxdrForm.get('totalDailyIngestion')?.value || 0"
                  placeholder="Enter daily ingestion in GB"
                  class="w-100"
                  (valueChange)="onTotalDailyIngestionChange($event)"
                ></kendo-numerictextbox>
                <kendo-formhint>
                  <kendo-svg-icon
                    [icon]="infoCircleIcon"
                    class="me-1"
                  ></kendo-svg-icon>
                  Expected daily data ingestion volume in gigabytes
                </kendo-formhint>
                @if (mxdrForm.get('totalDailyIngestion')?.invalid && mxdrForm.get('totalDailyIngestion')?.touched) {
                  <kendo-formerror>
                    <kendo-svg-icon
                      [icon]="exclamationTriangleIcon"
                      class="me-1"
                    ></kendo-svg-icon>
                    Daily ingestion is required and must be at least 0.1 GB
                  </kendo-formerror>
                }
              </kendo-formfield>
            </div>

            <!-- Extended Log Retention Required -->
            <div
              class="col-12"
              [class.col-lg-6]="!isNarrowLayout()"
            >
              <kendo-formfield>
                <kendo-label
                  [for]="cmmcExtendedLogRetention"
                  text="Extended Log Retention Required"
                ></kendo-label>
                <kendo-switch
                  formControlName="cmmcExtendedLogRetention"
                  #cmmcExtendedLogRetention
                  offLabel="No"
                  onLabel="Yes"
                ></kendo-switch>
                <kendo-formhint>
                  <kendo-svg-icon
                    [icon]="infoCircleIcon"
                    class="me-1"
                  ></kendo-svg-icon>
                  Enable extended log retention for CMMC compliance
                </kendo-formhint>
              </kendo-formfield>
            </div>
          </div>
        </div>
      </div>
    }
  </form>
</div>
